module.exports = __webpack_public_path__ + "static/media/credito-inicial-300x300.a45e5a71.jpg";